(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shopddf-contact-us"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const directory = document.querySelector('.shopddf-contact-us__directory');
    if (!directory) return;

    const locationSelect = directory.querySelector('[data-contact-location]');
    const consulateSelect = directory.querySelector('[data-contact-consulate]');
    if (!locationSelect || !consulateSelect) return;

    let consulatesByLocation = {};
    let salespersonsByGid = {};
    try {
      consulatesByLocation = JSON.parse(directory.dataset.consulatesByLocation || '{}');
    } catch (error) {
      consulatesByLocation = {};
    }
    try {
      salespersonsByGid = JSON.parse(directory.dataset.salespersonsByGid || '{}');
    } catch (error) {
      salespersonsByGid = {};
    }

    const salespersonDetailsEl = directory.querySelector('[data-salesperson-details]');
    const consulateFormWrapper = document.querySelector('[data-consulate-contact-wrapper]');
    const consulateInfoHeading = directory.dataset.consulateInfoHeading || 'CONSULATE INFORMATION:';

    const syncConsulateFormHiddenFields = () => {
      const loc = locationSelect.value || '';
      const cons = consulateSelect.value || '';
      if (consulateFormWrapper) {
        const locInput = consulateFormWrapper.querySelector('[data-consulate-form-location]');
        const consInput = consulateFormWrapper.querySelector('[data-consulate-form-consulate]');
        if (locInput) locInput.value = loc;
        if (consInput) consInput.value = cons;
      }
    };

    const renderSalesperson = (gid, spDirect) => {
      const sp = spDirect || (gid && salespersonsByGid[gid] ? salespersonsByGid[gid] : null);
      if (consulateFormWrapper) {
        consulateFormWrapper.hidden = !sp;
        consulateFormWrapper.setAttribute('aria-hidden', !!sp ? 'false' : 'true');
        if (sp) syncConsulateFormHiddenFields();
      }
      if (!salespersonDetailsEl) return;
      if (!sp) {
        salespersonDetailsEl.hidden = true;
        salespersonDetailsEl.innerHTML = '';
        return;
      }
      const name = sp.name ? escapeHtml(sp.name) : '';
      const title = sp.title ? escapeHtml(sp.title) : '';
      const email = sp.email ? escapeHtml(sp.email) : '';
      const phone = sp.phone ? escapeHtml(sp.phone) : '';
      const salespersonText = [name, title].filter(Boolean).join(', ');
      let html = '<div class="shopddf-contact-us__salesperson-inner">';
      html += `<p class="shopddf-contact-us__salesperson-heading">${ escapeHtml(consulateInfoHeading) }</p>`;
      html += '<div class="shopddf-contact-us__consulate-rows">';
      html += `<p class="shopddf-contact-us__consulate-row"><span class="shopddf-contact-us__consulate-label">Salesperson:</span> <span class="shopddf-contact-us__consulate-value">${ salespersonText || '—' }</span></p>`;
      html += `<p class="shopddf-contact-us__consulate-row"><span class="shopddf-contact-us__consulate-label">Phone:</span> <span class="shopddf-contact-us__consulate-value">${ phone || '—' }</span></p>`;
      html += `<p class="shopddf-contact-us__consulate-row"><span class="shopddf-contact-us__consulate-label">Email:</span> <span class="shopddf-contact-us__consulate-value">${ email || '—' }</span></p>`;
      html += '</div>';
      html += '</div>';
      salespersonDetailsEl.innerHTML = html;
      salespersonDetailsEl.hidden = false;
    };
    function escapeHtml (text) {
      const div = document.createElement('div');
      div.textContent = text;
      return div.innerHTML;
    }

    const resetConsulate = () => {
      consulateSelect.innerHTML = '<option value="">Select Consulate / Mission</option>';
      consulateSelect.disabled = true;
      renderSalesperson(null);
    };
    resetConsulate();

    const updateConsulates = (locationGid) => {
      resetConsulate();
      if (!locationGid) return;
      const consulates = consulatesByLocation[locationGid];
      if (!consulates || !Array.isArray(consulates) || !consulates.length) return;
      consulates.forEach((item) => {
        const option = document.createElement('option');
        option.value = item.value != null ? item.value : item.title;
        option.textContent = item.title != null ? item.title : item.value;
        if (item.salesperson_gid) option.dataset.salespersonGid = item.salesperson_gid;
        if (item.salesperson && typeof item.salesperson === 'object') {
          option.dataset.salesperson = JSON.stringify(item.salesperson);
        }
        consulateSelect.appendChild(option);
      });
      consulateSelect.disabled = false;
    };

    consulateSelect.addEventListener('change', () => {
      const selected = consulateSelect.options[consulateSelect.selectedIndex];
      let sp = null;
      if (selected && selected.dataset.salesperson) {
        try {
          sp = JSON.parse(selected.dataset.salesperson);
        } catch (e) {}
      }
      if (!sp && selected && selected.dataset.salespersonGid) {
        sp = salespersonsByGid[selected.dataset.salespersonGid] || null;
      }
      renderSalesperson(null, sp);
    });

    locationSelect.addEventListener('change', () => {
      updateConsulates(locationSelect.value);
    });

    const mainForm = document.getElementById('ContactForm');
    if (mainForm) {
      mainForm.addEventListener('submit', () => {
        const locInput = mainForm.querySelector('[data-main-form-location]');
        const consInput = mainForm.querySelector('[data-main-form-consulate]');
        if (locInput) locInput.value = locationSelect.value || '';
        if (consInput) consInput.value = consulateSelect.value || '';
      });
    }

    const consulateForm = document.getElementById('ContactFormConsulate');
    if (consulateForm) {
      consulateForm.addEventListener('submit', syncConsulateFormHiddenFields);
    }

    if (locationSelect.value) {
      updateConsulates(locationSelect.value);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
